import { render, staticRenderFns } from "./instant.vue?vue&type=template&id=73888213&scoped=true&"
import script from "./instant.vue?vue&type=script&lang=js&"
export * from "./instant.vue?vue&type=script&lang=js&"
import style0 from "./instant.vue?vue&type=style&index=0&id=73888213&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73888213",
  null
  
)

export default component.exports